<template>
  <div class="sidebar-left">
    <div class="sidebar">

      <!-- Logged In User Profile Sidebar -->
      <user-profile-sidebar
        :shall-show-user-profile-sidebar="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        @close-sidebar="$emit('update:shall-show-user-profile-sidebar', false)"
        shadow
        backdrop
      />

      <!-- Sidebar Content -->
      <div
        class="sidebar-content"
        :class="{'show': mqShallShowLeftSidebar}"
      >

        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <div class="sidebar-profile-toggle">
              <b-avatar
                size="40"
                class="cursor-pointer badge-minimal avatar-border-2"
                :src="profileUserData.avatar"
                variant="transparent"
                badge
                badge-variant="success"
                @click.native="$emit('show-user-profile')"
              />
            </div>
            <!-- Search -->
            <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchContacts"
                placeholder="Search or start a new chat"
              />
            </b-input-group>
          </div>
        </div>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >

          <!-- Chats Title -->
          <h4 class="chat-list-title text-default">
            Chats
          </h4>

          <!-- Chats -->
          <ul class="chat-users-list chat-list media-list border-bottom pb-50" v-if="filteredChatsContacts.length">
            <chat-contact
              v-for="contact in filteredChatsContacts"
              :key="contact.hashid"
              :user="contact"
              tag="li"
              :class="{'active': activeChatContactId === contact.hashid}"
              is-chat-contact
              @click="$emit('open-chat', contact.hashid,'chatThread')"
            />
          </ul>
          <div v-else class="m-1 d-flex flex-column align-items-center justify-content-center no-result">
            <!-- <img src="../../assets/images/icons/chat/noresult.svg" width="100px"> -->
            <h5 class="my-50"> No Chats Found</h5>
          </div>

          <!-- Contacts Title -->
          <h4 class="chat-list-title">
            Community Members
          </h4>

          <!-- Contacts -->
          <ul class="chat-users-list contact-list media-list" v-if="filteredContacts.length">
            <chat-contact
              v-for="contact in filteredContacts"
              :key="contact.hashid"
              :user="contact"
              tag="li"
              @click="$emit('open-chat', contact.hashid,'contact')"
            />
          </ul>
          <div v-if="searchContacts && !filteredContacts.length" class="m-1">
            <div class="m-1 d-flex flex-column align-items-center justify-content-center no-result">
              <!-- <img src="../../assets/images/icons/chat/noresult.svg" width="100px"> -->
              <h5 class="my-50"> No Users Found</h5>
            </div>
          </div>
        </vue-perfect-scrollbar>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BAvatar, BInputGroup, BInputGroupPrepend, BFormInput,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, computed } from '@vue/composition-api'
import ChatContact from './ChatContact.vue'
import UserProfileSidebar from './UserProfileSidebar.vue'

export default {
  components: {

    // BSV
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,

    // 3rd party
    VuePerfectScrollbar,

    // SFC
    ChatContact,
    UserProfileSidebar,
  },
  props: {
    chatsContacts: {
      type: Array,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    shallShowUserProfileSidebar: {
      type: Boolean,
      required: true,
    },
    profileUserData: {
      type: Object,
      required: true,
    },
    activeChatContactId: {
      type: String,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const resolveChatContact = userId => props.contacts.find(contact => contact.hashid === userId)

    // Search Query
    const searchContacts = ref('')

    const searchFilterFunction = contact => contact.name.toLowerCase().includes(searchContacts.value.toLowerCase())
    const filteredChatsContacts = computed(() => props.chatsContacts.filter(searchFilterFunction))
    const filteredContacts = computed(() => props.contacts.filter(searchFilterFunction))

    return {
      // Search Query
      searchContacts,
      filteredChatsContacts,
      filteredContacts,

      // UI
      resolveChatContact,
      perfectScrollbarSettings,
    }
  },
}
</script>
